<template>
  <chart-layout :title="title" :yAxis="yAxis" :xAxis="xAxis">
    <bar-graph
      :chart-data="data"
      :chart-id="chartIdOverride"
      :labelFunc="displayLabel">
    </bar-graph>
  </chart-layout>
</template>

<script>
import BarGraph from '@/components/graphs/BarGraph'
import ChartLayout from '@/components/layouts/ChartLayout'
import { commaFormatString } from '@/helpers'

export default {
  props: {
    chartIdOverride: {
      type: String,
      default: 'income-graph'
    },
    data: {
      type: Object
    }
  },
  components: {
    BarGraph,
    ChartLayout
  },
  data () {
    return {
      title: 'Income Distribution',
      yAxis: 'Viewship %',
      xAxis: 'Income Ranges'
    }
  },
  methods: {
    displayLabel (tooltip, data) {
      return `${data.datasets[tooltip.datasetIndex].label}: ${commaFormatString(String(tooltip.yLabel))} %`
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// IncomeGraph.vue?eed5aa42